import get from 'lodash/get'
import type { QuoteDocument, OptionsDocument } from 'paintscout'
import type { QuoteTypeOption, QuoteTemplateOption } from '../../../options'
import { getInitialPresentation } from '../../presentation'
import { updateToLatestTerms } from '../../quotes/transform-legacy-quote/update-to-latest-terms/update-to-latest-terms'
import { setPresentationTemplate } from '../../quotes/set-presentation-template/set-presentation-template'
import { getInitialTerms } from '../../terms'
import { calculateQuote } from '../../util/calculate/calculate-quote'
import { setQuoteType } from '../set-quote-type'

/**
 * Given a
 * @returns
 */
export function convertQuoteType({
  quote,
  quoteType,
  quoteTemplate,
  options
}: {
  quote: QuoteDocument
  quoteType: QuoteTypeOption
  quoteTemplate: QuoteTemplateOption
  options: OptionsDocument
}): QuoteDocument {
  const newQuote = setQuoteType({
    quote,
    options,
    quoteType: quoteType.key
  })

  const globalHourlyRate = get(options.options, 'hourlyRate.value')
  const quoteTypeHourlyRate = get(quoteType, 'hourlyRate')
  const hourlyRate = quoteTypeHourlyRate ? quoteTypeHourlyRate : globalHourlyRate
  const initialTerms = getInitialTerms({ options, quoteType })
  const updatedTerms = updateToLatestTerms({ terms: initialTerms, options })
  const presentationTemplate = getInitialPresentation({ options, quoteType })
  const convertedQuote = {
    ...newQuote,
    hourly_rate: Number(hourlyRate),
    terms: updatedTerms,
    presentationTemplate: setPresentationTemplate({ template: quoteTemplate, presentationTemplate, options })
  }
  const res = calculateQuote({ quote: convertedQuote, options })
  return res
}
